import React from 'react';
import useChapterActionIdMatch from "../../../../hooks/useChapterActionIdMatch";

function EmptyBodyCell({mode,option,action}) {
    const access = useChapterActionIdMatch(action)
    return (
        <>{mode === "edit" && option.editTable && access && (
            <td></td>
        )}</>
    );
}

export default EmptyBodyCell;